/* @flow */

import * as React from 'react';

import classnames from 'classnames';

import './body.module.css';

export type TextSize = 'mini' | 'tiny' | 'small' | 'normal' | 'large' | 'xlarge';

export type Color =
    | 'light'
    | 'medium'
    | 'dark'
    | 'person'
    | 'error'
    | 'blue'
    | 'white'
    | 'green'
    | 'blue-dk'
    | 'navy-dk'
    | 'plum'
    | 'ai-blue'
    | 'warn'
    | 'alert'
    | 'placeholder'
    | 'inherit'
    | 'ai-purple'
    | 'ai-purple-dk';

export type Props = {
    children?: React.Node,
    as?: string,
    size?: TextSize,
    color?: Color,
    isBold?: boolean,
    isItalic?: boolean,
    shouldTruncate?: boolean,
    truncateInline?: boolean,
    getBodyRef?: any,
    title?: string,
    underline?: boolean,
    strikethrough?: boolean,
    nowrap?: boolean,
    wrapAnywhere?: boolean,
    maintainLineBreaks?: boolean,
    preventCopy?: boolean,
    useDoyle?: boolean,
    isFullWidth?: boolean,
    textAlign?: 'left' | 'center' | 'right',
};

export function Body(props: Props) {
    const {
        as = 'span',
        size = 'normal',
        color = 'medium',
        isBold,
        isItalic,
        underline,
        strikethrough,
        shouldTruncate,
        getBodyRef,
        title,
        nowrap,
        wrapAnywhere,
        truncateInline,
        maintainLineBreaks,
        preventCopy,
        useDoyle,
        isFullWidth,
        textAlign,
    } = props;

    const Tag = shouldTruncate ? 'div' : as;

    const styleNames = classnames({
        body: true,
        mini: size === 'mini',
        tiny: size === 'tiny',
        small: size === 'small',
        normal: size === 'normal',
        large: size === 'large',
        xlarge: size === 'xlarge',
        light: color === 'light',
        medium: color === 'medium',
        dark: color === 'dark',
        person: color === 'person',
        error: color === 'error',
        blue: color === 'blue',
        white: color === 'white',
        green: color === 'green',
        placeholder: color === 'placeholder',
        plum: color === 'plum',
        'blue-dk': color === 'blue-dk',
        'navy-dk': color === 'navy-dk',
        'ai-blue': color === 'ai-blue',
        'ai-purple': color === 'ai-purple',
        'ai-purple-dk': color === 'ai-purple-dk',
        warn: color === 'warn',
        alert: color === 'alert',
        inherit: color === 'inherit',
        bold: isBold,
        italic: isItalic,
        underline,
        strikethrough,
        truncate: shouldTruncate,
        nowrap,
        'wrap-anywhere': wrapAnywhere,
        'truncate-inline': truncateInline,
        'maintain-line-breaks': maintainLineBreaks,
        'prevent-copy': preventCopy,
        doyle: useDoyle,
        'full-width': isFullWidth,
        'text-align-left': textAlign === 'left',
        'text-align-center': textAlign === 'center',
        'text-align-right': textAlign === 'right',
    });

    return (
        <Tag styleName={styleNames} ref={getBodyRef} title={title}>
            {props.children}
        </Tag>
    );
}
